// CLIENT PLUGIN
// src/blueprint/api/postPilotConsent.js

import apiFetch from '@wordpress/api-fetch';

export async function postPilotConsent(payload = {}) {
  return apiFetch({
    path: '/digivibe-savora/v1/savora/pilot/consent',
    method: 'POST',
    data: payload,
  });
}
